<template>
    <v-card class="d-flex px-3 justify-center align-center no-wrap" tile flat> 
        <v-card class="ma-1" tile flat>
            <v-icon v-if="connected" :color="symbolColor">mdi-network-outline</v-icon>
            <v-icon v-else :color="symbolColor">mdi-network-off-outline</v-icon>
        </v-card>
        <v-card class="ma-1" tile flat>
            {{ name }}
        </v-card>

        <v-spacer></v-spacer>

        <v-card class="ma-1" tile flat>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }"><v-btn icon v-on="on" @click="$store.dispatch('checkIntegrity', name)"><v-icon :color="symbolColor">mdi-shield-check-outline</v-icon></v-btn></template> 
                Check integrity
            </v-tooltip>
        </v-card>
        
        <v-card class="ma-1" tile flat>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }"><v-btn icon v-on="on" @click="$store.dispatch('forceReset', name)"><v-icon :color="symbolColor">mdi-restart-alert</v-icon></v-btn></template> 
                Force reset
            </v-tooltip>
        </v-card>

        <v-card class="ma-1" tile flat>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }"><v-btn icon v-on="on" @click="$store.state.selectedOperation=2"><v-icon :color="symbolColor">mdi-arrow-decision-auto-outline</v-icon></v-btn></template> 
                Enable/disable auto-policy
            </v-tooltip>
        </v-card>

        <v-card class="ma-1" tile flat>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }"><v-btn icon v-on="on" @click="$store.state.selectedOperation=3"><v-icon :color="symbolColor">mdi-information-outline</v-icon></v-btn></template> 
                Get system details
            </v-tooltip>
        </v-card>

    </v-card>
</template>



<script>

export default {
    props: {
        name:       String,
        connected:  Boolean,
        UID:        Array,
    },
    // data() {
    //     return {
    //         deviceName:     this.name,
    //         deviceOnline:   this.connected,
    //         deviceUID:      this.UID,
    //     };
    // },
    computed: {
        symbolColor: function() {
            return (this.connected ? "#769F3B" : "#928285");
        }
    },

    methods: {
    }
};
</script>